export function MailIcon() {
    return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden>
            <rect x="3" y="5" width="18" height="14" rx="2" stroke="#1e40af" strokeWidth="1.6" />
            <path d="M3 7l9 6 9-6" stroke="#1e40af" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export function SuccessIcon() {
    return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden>
            <circle cx="12" cy="12" r="9" fill="#15803d" />
            <path
                d="M7.5 12.2 10.7 15.4 16.8 8.8"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function PasswordRuleIcon({ ok }) {
    if (ok) {
        return (
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
                <circle cx="9" cy="9" r="9" fill="#22c55e" />
                <path
                    d="M5.2 9.05 7.85 11.7 12.8 5.95"
                    stroke="#ffffff"
                    strokeWidth="1.85"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );
    }

    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
            <circle cx="9" cy="9" r="9" fill="#e5e7eb" />
            <path
                d="M6.2 6.2 11.8 11.8M11.8 6.2 6.2 11.8"
                stroke="#22c55e"
                strokeWidth="1.85"
                strokeLinecap="round"
            />
        </svg>
    );
}

export function EyeIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path
                d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"
                stroke="currentColor"
                strokeWidth="1.6"
            />
            <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.6" />
        </svg>
    );
}

export function EyeOffIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path d="M3 3l18 18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            <path
                d="M10.6 10.6A3 3 0 0 0 12 15a3 3 0 0 0 2.4-1.2M6.7 6.7C4.6 8.1 3 10 3 10s3.5 7 10 7c1.8 0 3.4-.5 4.7-1.3M14.1 5.2C13.1 5.1 12.1 5 11 5 4.5 5 1 12 1 12s1.2 2.2 3.3 3.8"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}